import React from 'react';
import { Helmet } from 'react-helmet';

export const SITE_URL = 'https://www.backstepchain.com';
export const DEFAULT_SOCIAL_IMAGE = `${SITE_URL}/backstep-blockchain-social.jpg`;

const defaultDescription =
  'Back-Step Blockchain turns patented blockchain security into practical proof for products, ownership, digital money, AI accountability, and trusted records.';

export function SEO({
  title = 'Back-Step Blockchain | Trust you can show',
  description = defaultDescription,
  path = '/',
  image = DEFAULT_SOCIAL_IMAGE,
  type = 'website',
  jsonLd = [],
}) {
  const canonicalPath = path === '/' ? '/' : path.replace(/\/$/, '');
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;
  const fullTitle = title.includes('Back-Step Blockchain') ? title : `${title} | Back-Step Blockchain`;
  const jsonLdItems = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Back-Step Blockchain" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdItems.filter(Boolean).map((item, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Blockchain Systems Pte. Ltd.',
  alternateName: 'Back-Step Blockchain',
  url: SITE_URL,
  logo: `${SITE_URL}/site_icon_logo.png`,
  foundingDate: '2018',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'SG',
    addressLocality: 'Singapore',
  },
  email: 'info@blockchainsystems.vip',
  description: defaultDescription,
};

export const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Back-Step Blockchain',
  url: SITE_URL,
  publisher: {
    '@type': 'Organization',
    name: 'Blockchain Systems Pte. Ltd.',
  },
};
